import { useState } from "react";
import { useParams, useNavigate, Link } from "react-router-dom";
import { api, formatApiErrorDetail } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
import { Zap, CheckCircle2 } from "lucide-react";

export default function ResetPassword() {
  const { token } = useParams();
  const nav = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  const [err, setErr] = useState("");

  const submit = async (e) => {
    e.preventDefault();
    setErr("");
    if (password !== confirm) { setErr("Passwords do not match"); return; }
    if (password.length < 8) { setErr("Password must be at least 8 characters"); return; }
    setBusy(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      setDone(true);
      setTimeout(() => nav("/login"), 2000);
    } catch (e) {
      setErr(formatApiErrorDetail(e.response?.data?.detail) || "Failed");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center p-6">
      <div className="w-full max-w-md">
        <div className="bg-white border border-zinc-200 rounded-xl p-8 card-crisp">
          <div className="flex items-center gap-2 mb-6">
            <div className="w-9 h-9 rounded-md bg-[#FF5A00] flex items-center justify-center"><Zap className="w-5 h-5 text-white" strokeWidth={2.5}/></div>
            <div className="font-heading font-bold text-xl">LeadForge</div>
          </div>
          {done ? (
            <div className="text-center py-6" data-testid="reset-done">
              <CheckCircle2 className="w-12 h-12 text-emerald-500 mx-auto mb-3"/>
              <h1 className="font-heading text-2xl font-bold mb-2">Password reset</h1>
              <p className="text-zinc-600 text-sm">Redirecting to login…</p>
            </div>
          ) : (
            <>
              <h1 className="font-heading text-2xl font-bold mb-2">Set new password</h1>
              <p className="text-zinc-500 text-sm mb-6">At least 8 characters.</p>
              <form onSubmit={submit} className="space-y-4">
                <div>
                  <Label>New password</Label>
                  <Input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="reset-password-input"/>
                </div>
                <div>
                  <Label>Confirm password</Label>
                  <Input type="password" required value={confirm} onChange={(e)=>setConfirm(e.target.value)} data-testid="reset-confirm-input"/>
                </div>
                {err && <div className="text-sm text-rose-600" data-testid="reset-error">{err}</div>}
                <Button type="submit" disabled={busy} className="w-full bg-[#FF5A00] hover:bg-[#E04F00] text-white btn-lift" data-testid="reset-submit-btn">
                  {busy ? "Saving…" : "Reset password"}
                </Button>
                <Link to="/login" className="block text-center text-sm text-zinc-500 hover:text-zinc-900">Back to login</Link>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
